import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-4d5e2cc9"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "header-shell" };
const _hoisted_2 = { class: "site-container header-inner" };
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Mary Iglesias"),
    /*#__PURE__*/ _createElementVNode("small", null, "Escribana Pública")
], -1));
const _hoisted_5 = {
    class: "desktop-nav",
    "aria-label": "Navegación principal"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "header-actions" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", {
    class: "header-phone",
    href: "tel:+59899943824"
}, "099 943 824", -1));
const _hoisted_9 = ["aria-expanded"];
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, null, -1));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, null, -1));
const _hoisted_12 = [
    _hoisted_10,
    _hoisted_11
];
const _hoisted_13 = {
    id: "mobile-navigation",
    class: "mobile-menu"
};
const _hoisted_14 = { class: "mobile-menu__top" };
const _hoisted_15 = { class: "mobile-menu__brand" };
const _hoisted_16 = ["src"];
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Mary Iglesias", -1));
const _hoisted_18 = { "aria-label": "Navegación móvil" };
const _hoisted_19 = ["onClick"];
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "mobile-menu__contact" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "Contacto directo"),
    /*#__PURE__*/ _createElementVNode("a", { href: "tel:+59899943824" }, "+598 99 943 824"),
    /*#__PURE__*/ _createElementVNode("a", { href: "mailto:maryiglesiassosa@gmail.com" }, "maryiglesiassosa@gmail.com")
], -1));
import { nextTick, onMounted, onUnmounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Header',
    setup(__props) {
        const logo = new URL('@/assets/notarial-logo.png', import.meta.url).href;
        const drawer = ref(false);
        const scrolled = ref(false);
        const activeSection = ref('hero-section');
        const router = useRouter();
        const route = useRoute();
        const navItems = [
            { label: 'Servicios', section: 'services-section', route: '' },
            { label: 'Propiedades', section: '', route: 'properties' },
            { label: 'Sobre mí', section: 'about-section', route: '' },
            { label: 'Cómo trabajo', section: 'process-section', route: '' },
            { label: 'Contacto', section: 'contact-form', route: '' },
        ];
        const goHome = async () => {
            drawer.value = false;
            if (route.name !== 'home')
                await router.push({ name: 'home' });
            await nextTick();
            document.getElementById('hero-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };
        const navigate = async (item) => {
            drawer.value = false;
            if (item.route) {
                await router.push({ name: item.route });
                return;
            }
            if (route.name !== 'home')
                await router.push({ name: 'home' });
            await nextTick();
            document.getElementById(item.section)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };
        const handleScroll = () => {
            scrolled.value = window.scrollY > 12;
            for (const section of ['hero-section', ...navItems.map((item) => item.section).filter(Boolean)]) {
                const element = document.getElementById(section);
                if (element) {
                    const bounds = element.getBoundingClientRect();
                    if (bounds.top <= 120 && bounds.bottom >= 120) {
                        activeSection.value = section;
                        break;
                    }
                }
            }
        };
        onMounted(() => {
            window.addEventListener('scroll', handleScroll, { passive: true });
            handleScroll();
        });
        onUnmounted(() => window.removeEventListener('scroll', handleScroll));
        return (_ctx, _cache) => {
            const _component_q_header = _resolveComponent("q-header");
            const _component_q_drawer = _resolveComponent("q-drawer");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_q_header, {
                    class: _normalizeClass(["site-header", { 'site-header--scrolled': scrolled.value }])
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("button", {
                                class: "brand",
                                type: "button",
                                "aria-label": "Ir al inicio",
                                onClick: goHome
                            }, [
                                _createElementVNode("img", {
                                    src: _unref(logo),
                                    alt: ""
                                }, null, 8, _hoisted_3),
                                _hoisted_4
                            ]),
                            _createElementVNode("nav", _hoisted_5, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
                                    return _createElementVNode("button", {
                                        key: item.label,
                                        type: "button",
                                        class: _normalizeClass({ active: item.route ? _unref(route).name === item.route : activeSection.value === item.section }),
                                        onClick: ($event) => (navigate(item))
                                    }, _toDisplayString(item.label), 11, _hoisted_6);
                                }), 64))
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _hoisted_8,
                                _createElementVNode("button", {
                                    class: "menu-toggle",
                                    type: "button",
                                    "aria-expanded": drawer.value,
                                    "aria-controls": "mobile-navigation",
                                    "aria-label": "Abrir menú",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (drawer.value = !drawer.value))
                                }, _hoisted_12, 8, _hoisted_9)
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["class"]),
                _createVNode(_component_q_drawer, {
                    modelValue: drawer.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((drawer).value = $event)),
                    side: "right",
                    overlay: "",
                    width: 320,
                    class: "mobile-drawer"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("img", {
                                        src: _unref(logo),
                                        alt: ""
                                    }, null, 8, _hoisted_16),
                                    _hoisted_17
                                ]),
                                _createElementVNode("button", {
                                    type: "button",
                                    "aria-label": "Cerrar menú",
                                    onClick: _cache[1] || (_cache[1] = ($event) => (drawer.value = false))
                                }, "×")
                            ]),
                            _createElementVNode("nav", _hoisted_18, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item, index) => {
                                    return _createElementVNode("button", {
                                        key: item.label,
                                        type: "button",
                                        onClick: ($event) => (navigate(item))
                                    }, [
                                        _createElementVNode("small", null, "0" + _toDisplayString(index + 1), 1),
                                        _createTextVNode(" " + _toDisplayString(item.label), 1)
                                    ], 8, _hoisted_19);
                                }), 64))
                            ]),
                            _hoisted_20
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
